/* sd-cart-drawer.js — gaveta do carrinho da Sondur Travel (réplica nativa, sem app).
   Lê /cart.js, monta a marcação dentro de #sd-cart .sd-cart e cuida de abrir/fechar, +/−/remover,
   brindes que seguem a quantidade das almofadas, upsell e a bolha do cabeçalho. */
(function () {
  'use strict';
  if (window.__sdCartBooted) return;
  window.__sdCartBooted = true;
  var CFG = window.SdCartConfig || {};
  var root = document.getElementById('sd-cart');
  if (!root) return;
  var overlay = root.querySelector('.sd-cart-overlay');
  var layer = root.querySelector('.sd-cart-upsells-layer');
  var drawer = root.querySelector('.sd-cart');
  var announcer = root.querySelector('.sd-sc__cart-announcer');
  var tpl = document.getElementById('sd-cart-custom-html');
  var CUSTOM = tpl ? tpl.innerHTML : '';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var T = {
    title: 'Your Cart', close: 'Close cart', checkout: 'Secure Checkout', shippingLabel: 'Shipping',
    shippingValue: 'FREE SHIPPING', discounts: 'Discounts', total: 'Total', empty: 'Your cart is empty.',
    giftDiscount: 'FREE GIFT', upsellHeading: '87% of customers also added:', upsellAdd: 'Add', originalPrice: 'Original price '
  };
  var k;
  for (k in (CFG.text || {})) T[k] = CFG.text[k];
  var CUSHIONS = CFG.cushionHandles || [];
  var ANN = CFG.announcements || [];
  var UPSELL = CFG.upsell || null;

  var X_PATH = '<path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="FILL" fill-rule="nonzero"></path>';
  var SVG = {
    close: '<svg aria-hidden="true" focusable="false" width="10" viewBox="0 0 10 10">' + X_PATH.replace('FILL', '#A1A1A1') + '</svg>',
    remove: '<svg aria-hidden="true" focusable="false" width="9" viewBox="0 0 10 10">' + X_PATH.replace('FILL', '#cacaca') + '</svg>',
    minus: '<svg aria-hidden="true" focusable="false" width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z" fill="#7A7A7A" fill-rule="nonzero"></path></svg>',
    plus: '<svg aria-hidden="true" focusable="false" width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg>',
    tag: function (cls) {
      return '<svg aria-hidden="true" focusable="false" class="' + cls + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="14px" height="14px"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55" fill="currentColor"></path><path fill="currentColor" d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>';
    },
    empty: '<svg aria-hidden="true" focusable="false" width="56" viewBox="0 0 65 74" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="none"><path d="M64.407 9.856L53.605 0H11.371L.569 9.856A1.548 1.548 0 00.1 11.603c.235.619.843 1.031 1.524 1.031h61.727a1.62 1.62 0 001.522-1.031 1.545 1.545 0 00-.467-1.747z" fill="#C4C4C4"></path><path d="M63.351 9.927H1.624C.728 9.927 0 10.644 0 11.529v59.267C0 72.566 1.454 74 3.249 74h58.478c1.795 0 3.249-1.434 3.249-3.204V11.53c0-.885-.728-1.602-1.625-1.602z" fill="#E4E4E4"></path><path d="M32.488 45.122c-7.963 0-14.44-6.447-14.44-14.37v-4.79a1.6 1.6 0 011.605-1.596 1.6 1.6 0 011.604 1.596v4.79c0 6.163 5.04 11.177 11.23 11.177 6.192 0 11.231-5.014 11.231-11.177v-4.79a1.6 1.6 0 011.604-1.596 1.6 1.6 0 011.605 1.596v4.79c0 7.923-6.477 14.37-14.44 14.37z" fill="#6D6D6D"></path></g></svg>'
  };

  var state = { cart: null, products: {}, open: false, busy: 0 };

  function money(cents) {
    var s = (Math.round(cents) / 100).toFixed(2), p = s.split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + p.join('.');
  }
  function moneyLoose(cents) { return '$' + (Math.round(cents) / 100); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function img160(src) {
    if (!src) return '';
    return src.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_160x$1$2');
  }
  var GIFT_IDS = (CFG.gifts || []).map(function (g) { return Number(g.variantId); }).filter(Boolean);
  function isGift(item) { return !!(item.properties && item.properties._Gifted) || GIFT_IDS.indexOf(Number(item.variant_id)) >= 0 || /-free-gift$/.test(item.handle || ''); }
  function isCushion(item) { return CUSHIONS.indexOf(item.handle) >= 0; }
  function compareAt(item) {
    var p = state.products[item.handle];
    if (p && p.variants) {
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].id === item.variant_id) return p.variants[i].compare_at_price || 0;
      }
    }
    return 0;
  }
  function unitOriginal(item) { return compareAt(item) || item.original_price; }
  function lineStrike(item) {
    var orig = unitOriginal(item) * item.quantity;
    return orig > item.final_line_price ? orig : 0;
  }
  function findItem(key) {
    var items = (state.cart && state.cart.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i].key === key) return items[i];
    return null;
  }
  function announce(msg) { if (announcer) announcer.textContent = msg || ''; }

  /* ---------- marcação ---------- */
  function renderHeader(cart) {
    var count = cart.item_count ? '<span class="cart-count">' + cart.item_count + '</span>' : '';
    return '<header class="header" data-testid="Header" role="presentation"><span role="heading" aria-level="2">' + esc(T.title) + ' ' + count +
      '</span><button type="button" aria-label="' + esc(T.close) + '">' + SVG.close + '</button></header>';
  }
  function renderEmpty() {
    return '<div class="empty"><div class="empty-cart-container empty-cart-wrapper"><div class="empty-cart-content"><div class="sd-sc__empty-cart-icon-text">' + SVG.empty +
      '<div class="empty-cart-text-container"><p class="empty-cart-text-title">' + esc(T.empty) + '</p></div></div></div></div></div>';
  }
  function renderAnnouncements() {
    if (!ANN.length) return '';
    var slides = '';
    for (var i = 0; i < ANN.length; i++) {
      slides += '<div data-index="' + i + '" class="slick-slide' + (i === 0 ? ' slick-active slick-current' : '') + '" tabindex="-1" aria-hidden="' + (i === 0 ? 'false' : 'true') + '" style="outline: none;"><div><p tabindex="-1" style="width: 100%; display: inline-block;">' + esc(ANN[i]) + '</p></div></div>';
    }
    return '<div class="announcements" data-testid="Announcements"><div class="slick-slider slick-initialized"><div class="slick-list"><div class="slick-track" style="opacity: 1; transform: translate3d(0px, 0px, 0px);">' + slides + '</div></div></div></div>';
  }
  function renderPrice(strike, finalCents) {
    var h = '<p class="price-discount-block">';
    if (strike) {
      h += '<span class="sd-sc__visually-hidden">' + esc(T.originalPrice) + '</span><span class="price strike-through line-item-discount" style="opacity: 0.7; text-decoration: line-through;">' + money(strike) + '</span>';
    }
    return h + '<span class="price">' + money(finalCents) + '</span></p>';
  }
  function renderItem(item) {
    var title = esc(item.product_title || item.title);
    var url = esc(item.url || ('/products/' + item.handle));
    var props = '';
    if (item.properties) {
      var lis = '';
      for (var p in item.properties) {
        if (item.properties[p] == null || item.properties[p] === '') continue;
        lis += '<li data-key="' + esc(p) + '"><span class="properties-key-value-key">' + esc(p) + '</span><span class="properties-key-value-spacer">: </span><span class="properties-key-value-value">' + esc(item.properties[p]) + '</span></li>';
      }
      if (lis) props = '<ul class="properties-key-value">' + lis + '</ul>';
    }
    var titles = [];
    (item.line_level_discount_allocations || []).forEach(function (a) {
      var t = a.discount_application && a.discount_application.title;
      if (t && titles.indexOf(t) < 0) titles.push(t);
    });
    if (isGift(item) && titles.indexOf(T.giftDiscount) < 0) titles.push(T.giftDiscount);
    var allocs = '';
    titles.forEach(function (t) {
      allocs += '<div class="discount-allocations"><div class="discount-allocations-flex-initial">' + SVG.tag('discount-allocations-tags-icon') + '</div><div class="discount-allocations-flex-1">' + esc(t) + '</div></div>';
    });
    var strike = lineStrike(item);
    var badge = '';
    if (item.final_line_price > 0 && strike > item.final_line_price) {
      badge = '\n            \n<span class="saveBadgeSdCart">\n              (SAVE ' + moneyLoose(strike - item.final_line_price) + ')\n            \n          </span>';
    }
    var q = item.quantity;
    var lock = isGift(item) ? ' disabled aria-disabled="true" tabindex="-1" style="visibility:hidden"' : ' aria-disabled="false"';
    return '<div class="item" role="listitem" data-line-item-id="' + item.variant_id + '" data-variant-id="' + item.variant_id + '" data-line-item-key="' + esc(item.key) + '">' +
      '<div class="item-container"><a class="item-image-anchor" href="' + url + '" aria-hidden="true" tabindex="-1"><img alt="' + title + '" src="' + esc(img160(item.image)) + '"></a>' +
      '<div class="main"><div class="main-top"><div class="main-top-left"><span class="title"><a href="' + url + '">' + title + '</a></span>' + props + allocs + '</div>' +
      '<button type="button" class="remove"' + (isGift(item) ? ' disabled tabindex="-1" style="visibility:hidden"' : '') + ' aria-label="Remove ' + title + '">' + SVG.remove + '</button></div>' +
      '<div class="main-bottom"><div class="quantity-selector">' +
      '<button type="button"' + lock + ' aria-label="Decrease quantity of ' + title + '">' + SVG.minus + '</button>' +
      '<input type="text" aria-label="Quantity of ' + title + '" role="spinbutton" aria-valuenow="' + q + '" aria-valuemin="0" aria-valuetext="' + q + '" value="' + q + '"' + (isGift(item) ? ' readonly tabindex="-1"' : '') + '>' +
      '<button type="button"' + lock + ' aria-label="Increase quantity of ' + title + '">' + SVG.plus + '</button></div>' +
      renderPrice(strike, item.final_line_price) + '</div>' + badge + '</div></div></div>';
  }
  function renderUpsell(cart) {
    if (!UPSELL || !UPSELL.variantId) return '';
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].handle === UPSELL.handle) return '';
    var title = esc(UPSELL.title), url = esc(UPSELL.url);
    var cmp = UPSELL.compareAt > UPSELL.price ? '<span class="sd-sc__visually-hidden">' + esc(T.originalPrice) + '</span><p class="upsell-compare-at">' + money(UPSELL.compareAt) + '</p>' : '';
    return '<div class="upsells upsells-stacked-container sd-sc__upsells-carousel " data-testid="Aupsells"><div class="upsells-header "><span>' + esc(T.upsellHeading) + '</span></div>' +
      '<div class="slick-slider slick-initialized"><div class="slick-list"><div class="slick-track" style="opacity: 1; transform: translate3d(0px, 0px, 0px);">' +
      '<div data-index="0" class="slick-slide slick-active slick-current" tabindex="-1" aria-hidden="false" style="outline: none;"><div>' +
      '<div data-sd-cart-product-id="' + UPSELL.productId + '" class="upsell"><div class="upsell-item">' +
      '<div class="upsell-image"><a href="' + url + '" aria-hidden="true" tabindex="-1"><img alt="' + title + '" class="small" src="' + esc(UPSELL.image) + '"></a></div>' +
      '<div class="upsell-text"><p><a href="' + url + '" data-testid="AupsellTitle">' + title + '</a></p><div class="upsell-text-prices"><p data-testid="AupsellPrice">' + money(UPSELL.price) + '</p>' + cmp + '</div></div>' +
      '<div class="upsell-add"><button type="button" aria-label="' + esc(T.upsellAdd) + ' ' + title + ' for ' + money(UPSELL.price) + '">' + esc(T.upsellAdd) + '</button></div>' +
      '</div></div></div></div></div></div></div></div>';
  }
  function renderFooter(cart) {
    var titles = [], giftTotal = 0, strikeTotal = 0;
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && a.discount_application.title;
        if (t && titles.indexOf(t) < 0) titles.push(t);
      });
      if (isGift(it)) giftTotal += unitOriginal(it) * it.quantity;
      strikeTotal += unitOriginal(it) * it.quantity;
    });
    if (giftTotal > 0 && titles.indexOf(T.giftDiscount) < 0) titles.push(T.giftDiscount);
    var discount = (cart.total_discount || 0) + giftTotal;
    var h = '<footer class="footer">';
    h += '<div class="footer-row"><span class="shipping-label flex">' + esc(T.shippingLabel) + '</span><span class="shipping-cost"><span>' + esc(T.shippingValue) + '</span></span></div>';
    if (titles.length) {
      var codes = '';
      titles.forEach(function (t) {
        codes += '<span class="footer-code">' + SVG.tag('footer-tags-icon') + esc(esc(t)) + '<button type="button" aria-label="Remove discount ' + esc(esc(t)) + '">' + SVG.close + '</button></span>';
      });
      h += '<div class="footer-row"><span class="footer-row-flex flex sd-sc__footer-row--discount">' + esc(T.discounts) + codes + '</span><span class="sd-cart-discount-amount">-' + money(discount) + '</span></div>';
    }
    var savings = strikeTotal - cart.total_price;
    h += '<div class="footer-row sd-sc__footer-row--subtotal"><strong class="flex subtotal-label"><span>' + esc(T.total) + '</span></strong><span class="footer-subtotal-wrapper">';
    if (savings > 0) h += '<span class="savings-text" style="color: rgb(0, 193, 84);">Save ' + money(savings) + '</span>';
    h += '<span class="footer-subtotal-prices">';
    if (savings > 0) h += '<span class="sd-sc__visually-hidden">' + esc(T.originalPrice) + '</span><span class="price strike-through line-item-discount" style="opacity: 0.7; text-decoration: line-through;">' + money(strikeTotal) + '</span>';
    h += '<strong class="sd-cart-subtotal">' + money(cart.total_price) + '</strong></span></span></div>';
    h += '<form id="sd-cart-checkout-form" action="/cart" method="post"><button type="button" name="checkout" class="button full">' + esc(T.checkout) + '</button></form>';
    h += '<div class="custom-html"><div>' + CUSTOM + '</div></div>';
    return h + '</footer>';
  }
  function fitSlick() {
    var sliders = root.querySelectorAll('.slick-slider');
    for (var i = 0; i < sliders.length; i++) {
      var sl = sliders[i], list = sl.querySelector('.slick-list'), track = sl.querySelector('.slick-track');
      if (!list || !track) continue;
      var w = Math.round(list.getBoundingClientRect().width) || list.clientWidth;
      var slides = track.children, n = slides.length;
      track.style.cssText = 'width: ' + (w * n) + 'px; opacity: 1; transform: translate3d(0px, 0px, 0px);';
      for (var j = 0; j < n; j++) slides[j].style.cssText = 'outline: none; width: ' + w + 'px;';
      if (sl.parentNode && sl.parentNode.classList.contains('announcements') && slides[0]) {
        list.style.height = slides[0].offsetHeight + 'px';
      }
    }
  }
  function render() {
    var cart = state.cart;
    if (!cart) return;
    var empty = !cart.item_count;
    var top = drawer.scrollTop;
    classes();
    drawer.setAttribute('aria-label', T.title + ', ' + (empty ? 'empty' : cart.item_count + (cart.item_count === 1 ? ' item' : ' items')));
    var html = renderHeader(cart);
    if (empty) {
      html += renderEmpty();
    } else {
      var items = '', ordem = cart.items.filter(function (it) { return !isGift(it); }).concat(cart.items.filter(isGift));
      ordem.forEach(function (it) { items += renderItem(it); });
      html += renderAnnouncements() + '<div class="items" role="list">' + items + '</div>' + renderUpsell(cart) + renderFooter(cart);
    }
    drawer.innerHTML = html;
    fitSlick();
    drawer.scrollTop = top;
  }

  /* ---------- dados ---------- */
  function api(path, body) {
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(ROOT + path, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function loadProducts(cart) {
    var need = [];
    cart.items.forEach(function (it) {
      if (!(it.handle in state.products) && need.indexOf(it.handle) < 0) need.push(it.handle);
    });
    return Promise.all(need.map(function (h) {
      state.products[h] = null;
      return fetch(ROOT + 'products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { state.products[h] = j; })
        .catch(function () { state.products[h] = null; });
    }));
  }
  /* brindes: 1 por kit, nunca acima do número de almofadas e fora do carrinho sem almofada */
  var guarding = false;
  function giftUpdates(cart) {
    var total = 0, up = {}, mexe = false;
    cart.items.forEach(function (it) { if (isCushion(it)) total += it.quantity; });
    cart.items.forEach(function (it) {
      if (!isGift(it)) return;
      var q = Math.min(it.quantity, total);
      if (q !== it.quantity) { up[it.key] = q; mexe = true; }
    });
    return mexe ? up : null;
  }
  function setCart(cart) {
    var up = guarding ? null : giftUpdates(cart);
    if (up) {
      guarding = true;
      return api('cart/update.js', { updates: up }).then(function (c) {
        guarding = false;
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        return setCart(c);
      }, function () { guarding = false; state.cart = cart; return loadProducts(cart).then(render); });
    }
    state.cart = cart;
    return loadProducts(cart).then(render);
  }
  function refresh() {
    return api('cart.js').then(setCart).catch(function () {});
  }
  function bubble() {
    return fetch(ROOT + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['cart-icon-bubble'];
        var el = document.getElementById('cart-icon-bubble');
        if (!html || !el) return;
        var d = document.createElement('div');
        d.innerHTML = html;
        var sec = d.querySelector('.shopify-section');
        el.innerHTML = sec ? sec.innerHTML : html;
      }).catch(function () {});
  }
  function afterChange(cart) {
    return setCart(cart).then(bubble);
  }
  function busy(on) {
    state.busy = Math.max(0, state.busy + (on ? 1 : -1));
    drawer.classList.toggle('loading', state.busy > 0);
  }
  function fail(e) {
    announce((e && (e.description || e.message)) || 'Could not update the cart. Please try again.');
    return refresh();
  }
  function changeLine(item, qty) {
    if (state.busy) return Promise.resolve();
    busy(true);
    var p;
    if (isCushion(item)) {
      var updates = {}, total = 0;
      updates[item.key] = qty;
      state.cart.items.forEach(function (it) {
        if (isCushion(it)) total += (it.key === item.key ? qty : it.quantity);
      });
      state.cart.items.forEach(function (it) {
        if (isGift(it)) updates[it.key] = Math.min(it.quantity, total);
      });
      p = api('cart/update.js', { updates: updates });
    } else {
      p = api('cart/change.js', { id: item.key, quantity: qty });
    }
    return p.then(afterChange).catch(fail).then(function () { busy(false); });
  }
  function addUpsell() {
    if (state.busy || !UPSELL) return Promise.resolve();
    busy(true);
    return api('cart/add.js', { items: [{ id: UPSELL.variantId, quantity: 1 }] })
      .then(function () { return api('cart.js'); })
      .then(afterChange).catch(fail).then(function () { busy(false); });
  }

  /* ---------- abrir / fechar ---------- */
  function classes() {
    var empty = !state.cart || !state.cart.item_count;
    drawer.className = 'sd-cart right light' + (state.open ? ' open' : '') + (empty ? ' cartEmpty' : '') + ' checkpoint';
  }
  function open() {
    overlay.classList.add('open');
    layer.classList.add('open');
    state.open = true;
    classes();
    try { (drawer.querySelector('header.header button') || drawer).focus({ preventScroll: true }); } catch (e) {}
  }
  function close() {
    overlay.classList.remove('open');
    layer.classList.remove('open');
    state.open = false;
    classes();
  }
  function openFresh() {
    return refresh().then(open);
  }
  window.sdCartOpen = openFresh;
  window.sdCartClose = close;
  window.sdCartRefresh = refresh;

  /* ---------- eventos ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t === overlay || t.closest('header.header button')) { close(); return; }
    var itemEl = t.closest('.item');
    if (itemEl) {
      var it = findItem(itemEl.getAttribute('data-line-item-key'));
      if (!it || isGift(it)) return;
      if (t.closest('button.remove')) { changeLine(it, 0); return; }
      var qs = t.closest('.quantity-selector');
      if (qs) {
        var btn = t.closest('button');
        if (!btn) return;
        var delta = btn === qs.querySelector('button') ? -1 : 1;
        changeLine(it, Math.max(0, it.quantity + delta));
        return;
      }
      return;
    }
    if (t.closest('.upsell-add button')) { addUpsell(); return; }
    if (t.closest('#sd-cart-checkout-form button, form.custom-checkout-form button')) {
      e.preventDefault();
      window.location.href = ROOT + 'checkout';
    }
  });
  root.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('.quantity-selector input')) return;
    var itemEl = inp.closest('.item');
    var it = itemEl && findItem(itemEl.getAttribute('data-line-item-key'));
    if (it && isGift(it)) { inp.value = it.quantity; return; }
    var q = parseInt(inp.value, 10);
    if (it && !isNaN(q) && q >= 0 && q !== it.quantity) changeLine(it, q);
    else inp.value = it ? it.quantity : 0;
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('.quantity-selector input')) {
      e.preventDefault();
      e.target.blur();
    }
  });
  root.addEventListener('submit', function (e) {
    e.preventDefault();
    window.location.href = ROOT + 'checkout';
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) close();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('#cart-icon-bubble, a[href="/cart"], a[href="' + ROOT + 'cart"]');
    if (!a || a.closest('#sd-cart')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openFresh();
  }, true);

  /* Dawn (PDPs nativas): o popup cart-notification vira a gaveta */
  function hookDawn() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-notification').then(function () {
      var C = customElements.get('cart-notification');
      if (!C || !C.prototype) return;
      C.prototype.renderContents = function () { openFresh(); };
      C.prototype.open = function () {};
    }).catch(function () {});
  }
  hookDawn();
  refresh();
})();
